module.exports.generate = function(errorCode, requestId, errorMessage) {
    var response = { result: false };

    if (requestId != null && requestId != undefined)
        response.req_id = requestId;

    response.error_code = errorCode;

    if (errorMessage != null && errorMessage != undefined)
        response.error_message = errorMessage;

    return response;
}